import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import React, { useState } from 'react';
import Dropzone from 'react-dropzone';
import FileIcon from '../icons/FileIcon';
const CSVImport = ({ alias }) => {
    const [dragState, setDragState] = useState(false);
    const [uploadMessage, setUploadMessage] = useState(_jsx("span", {}));
    const handleDrop = async (acceptedFiles) => {
        var _a;
        // mixpanel.track("Other Connect Completed")
        const formData = new FormData();
        formData.append("customers", acceptedFiles[0]);
        let token = ((_a = document.querySelector('meta[name="withfriends:t"]')) === null || _a === void 0 ? void 0 : _a.getAttribute('content')) || null;
        try {
            const response = await fetch(process.env.REACT_APP_RAILS_API + `/merchants/${alias}/customers/import`, {
                method: 'POST',
                body: formData,
                headers: [
                    ["Authorization", `Bearer ${token}`],
                ],
            });
            if (response.ok) {
                setUploadMessage(_jsx("div", { className: "my-4 p-2 border border-wfGray-300", children: "Success! We're processing your upload and will email you when it's done." }));
            }
            else {
                const msg = await response.json();
                setUploadMessage(_jsxs("div", { className: "my-4 p-2 border-2 border-salmon-600", children: [_jsx("strong", { children: "Oh no! There was an error in your upload." }), _jsx("br", {}), " Check your template and try again, or email it to team@withfriends.co and we'll help you out."] }));
            }
        }
        catch (_b) {
            setUploadMessage(_jsxs("div", { className: "my-4 p-2 border-2 border-salmon-600", children: [_jsx("strong", { children: "Oh no! There was an error in your upload." }), _jsx("br", {}), " Check your template and try again, or email it to team@withfriends.co and we'll help you out."] }));
        }
        setDragState(false);
        return true;
    };
    const handleDragOver = (ev) => {
        setDragState(true);
        ev.preventDefault();
    };
    const handleDragLeave = (ev) => {
        setDragState(false);
        ev.preventDefault();
    };
    const noDragClasses = "border-2 border-gray-400 border-dashed p-4 hover:border-gray-800 text-center cursor-pointer";
    const dragClasses = "bg-gray-200 border-gray-800 " + noDragClasses;
    return (_jsxs("div", { children: [_jsx("p", { className: "mb-2 text-center", children: _jsx("a", { href: "/react/template.csv", download: true, children: "Download a template." }) }), uploadMessage, _jsx(Dropzone, { onDrop: handleDrop, onDragOver: handleDragOver, onDragLeave: handleDragLeave, children: ({ getRootProps, getInputProps }) => (_jsx("section", { className: dragState ? dragClasses : noDragClasses, children: _jsxs("div", Object.assign({}, getRootProps(), { children: [_jsx("input", Object.assign({}, getInputProps())), _jsx("span", { children: "Drag a CSV, or click to select a file" }), _jsx(FileIcon, { className: "h-12 w-12 fill-current mt-4 mx-auto text-gray-500" })] })) })) })] }));
};
export default CSVImport;
